// Every storefront guest is the same anonymous shop account, so the backend
// only lets a guest reach a guest record when the request proves this browser
// created it: POST /patients/ answers a signed `guest_token` for the new
// record, and every guest request on that record (its details, its shipping
// addresses, the order placed for it) sends it back in this header. Without a
// valid one the backend answers 404, as if the record did not exist.
export const GUEST_TOKEN_HEADER = "X-Guest-Token";

// The axios request config a patient/order thunk passes: the header when this
// browser is a guest holding a token, else nothing. A logged-in customer is
// known by its JWT. No token means no header, so the request needs no new CORS
// preflight: only a backend that accepts the header hands a token out.
export const guestRequestConfig = (state) => {
  const token = state?.patient?.unAuthenticatedGuestToken;
  if (state?.auth?.isAuthenticated || !token || typeof token !== "string") {
    return undefined;
  }
  return { headers: { [GUEST_TOKEN_HEADER]: token } };
};
